import { render, staticRenderFns } from "./OpenSourceSoftwareView.vue?vue&type=template&id=1cf34c64&scoped=true"
import script from "./OpenSourceSoftwareView.vue?vue&type=script&lang=js"
export * from "./OpenSourceSoftwareView.vue?vue&type=script&lang=js"
import style0 from "./OpenSourceSoftwareView.vue?vue&type=style&index=0&id=1cf34c64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf34c64",
  null
  
)

export default component.exports